import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { OPERATIONAL_EVENT_TYPE, SCREEN_EVENT_TYPE, TRACK_EVENT_TYPE, UI_EVENT_TYPE } from '@atlaskit/analytics-gas-types';
import { FabricChannel } from '@atlaskit/analytics-listeners/types';
import { CrossType } from './types';
export var NOTIFICATION_CHANNEL = FabricChannel.notifications;
export var triggerScreenEvent = function triggerScreenEvent(createAnalyticsEvent, payload, analyticsContext) {
  var analyticsEvent = createAnalyticsEvent(_objectSpread(_objectSpread({}, payload), {}, {
    eventType: SCREEN_EVENT_TYPE,
    attributes: _objectSpread({}, payload.attributes),
    name: payload.name
  }, getTenantFields(analyticsContext)));
  analyticsEvent.clone();
  analyticsEvent.fire(NOTIFICATION_CHANNEL);
};
export var triggerUIEvent = function triggerUIEvent(createAnalyticsEvent, payload, analyticsContext) {
  var analyticsEvent = createAnalyticsEvent(_objectSpread(_objectSpread({}, payload), {}, {
    eventType: UI_EVENT_TYPE,
    attributes: _objectSpread({}, payload.attributes)
  }, getTenantFields(analyticsContext)));
  analyticsEvent.clone();
  analyticsEvent.fire(NOTIFICATION_CHANNEL);
};
export var triggerOperationalEvent = function triggerOperationalEvent(createAnalyticsEvent, payload, analyticsContext) {
  createAnalyticsEvent(_objectSpread(_objectSpread({}, payload), {}, {
    eventType: OPERATIONAL_EVENT_TYPE,
    attributes: _objectSpread({}, payload.attributes)
  }, getTenantFields(analyticsContext))).fire(NOTIFICATION_CHANNEL);
};
export var triggerTrackEvent = function triggerTrackEvent(createAnalyticsEvent, payload, analyticsContext) {
  var analyticsEvent = createAnalyticsEvent(_objectSpread(_objectSpread({}, payload), {}, {
    eventType: TRACK_EVENT_TYPE,
    attributes: _objectSpread({}, payload.attributes)
  }, getTenantFields(analyticsContext)));
  analyticsEvent.clone();
  analyticsEvent.fire(NOTIFICATION_CHANNEL);
};
var getUserHourOfDay = function getUserHourOfDay() {
  return new Date().getHours();
};
var getTenantFields = function getTenantFields(analyticsContext) {
  if (analyticsContext.cloudId) {
    return {
      tenantIdType: 'cloudId',
      tenantId: analyticsContext.cloudId
    };
  } else {
    return {
      tenantIdType: 'none'
    };
  }
};
var isCrossSite = function isCrossSite(notification, analyticsContext) {
  if (analyticsContext.cloudId === undefined || notification.analyticsAttributes.cloudId === undefined) {
    return CrossType.UNKNOWN;
  } else if (notification.analyticsAttributes.cloudId && analyticsContext.cloudId.toUpperCase() !== notification.analyticsAttributes.cloudId.toUpperCase()) {
    return CrossType.TRUE;
  }
  return CrossType.FALSE;
};
var isCrossProduct = function isCrossProduct(notification, analyticsContext) {
  if (analyticsContext.product === undefined || notification.analyticsAttributes.registrationProduct === undefined) {
    return CrossType.UNKNOWN;
  } else if (analyticsContext.product.toUpperCase() === notification.analyticsAttributes.registrationProduct.toUpperCase()) {
    return CrossType.FALSE;
  }
  return CrossType.TRUE;
};
var INFINITY = '+Inf';
export var getRenderBucket = function getRenderBucket(renderTime, buckets) {
  return renderTime >= 0 ? buckets.reduce(function (lowestBucket, currentBucket) {
    return renderTime <= parseInt(currentBucket) ? currentBucket : lowestBucket;
  }, INFINITY) : null;
};
export var getDefaultAttributes = function getDefaultAttributes(analyticsContext) {
  return {
    userHourOfDay: getUserHourOfDay(),
    readStateFilter: analyticsContext.readStateFilter,
    categoryFilter: analyticsContext.requestCategory,
    productFilter: analyticsContext.productFilter,
    product: analyticsContext.product,
    view: analyticsContext.view
  };
};
export var getNotificationAttributes = function getNotificationAttributes(notification, listIndex) {
  return _objectSpread({
    listIndex: listIndex,
    notificationAgeInSeconds: Math.floor((Date.now() - new Date(notification.timestamp).getTime()) / 1000),
    notificationCategory: notification.category || 'watching',
    notificationReadState: notification.readState
  }, notification.analyticsAttributes);
};
export var getNotificationGroupAttributes = function getNotificationGroupAttributes(notificationGroup, listIndex) {
  var byMostRecent = function byMostRecent(a, b) {
    return new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime();
  };
  var mostRecentNotification = notificationGroup.notifications.sort(byMostRecent).find(function () {
    return true;
  });
  if (mostRecentNotification === undefined) {
    return {};
  }
  return getNotificationAttributes(mostRecentNotification, listIndex);
};
export var getCrossAttributes = function getCrossAttributes(notification, analyticsContext) {
  return {
    isCrossSite: isCrossSite(notification, analyticsContext),
    isCrossProduct: isCrossProduct(notification, analyticsContext),
    // PlatformExperienceCommonContext
    platformCtx: 'notifications',
    destinationProduct: notification.analyticsAttributes.registrationProduct || '_unknown',
    destinationObjectId: notification.id,
    destinationTenantId: notification.analyticsAttributes.cloudId || '_unknown'
  };
};
export var getNotificationContainer = function getNotificationContainer(notification) {
  return {
    containers: {
      notification: {
        id: notification.id
      }
    }
  };
};